import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";
import MobileHelper from "../../../../../helpers/mobile";
import typeCollaboration from "./type-collaboration";
import editMarketerValidation from "../../../../../validtions/forms/user/marketer/edit-marketer";

export default function EditMarketer() {
  const history = useHistory();
  const [message, setMessage] = useState();
  const [permanentPercent, setPermanentPercent] = useState(0);
  const [countPermanentPercent, setCountPermanentPercent] = useState(0);
  const [typeCollaborationUser, setTypeCollaborationUser] = useState();
  const params = useParams();
  const userMarketerID = params.id;
  const [userMarketer, setUserMarketer] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getUserMarketer();
  }, []);

  useEffect(() => {
    if (!userMarketer) {
      return;
    }

    setPermanentPercent(userMarketer.mar_permanent_percent);
    setTypeCollaborationUser(userMarketer.mar_type_collaboration);
    setCountPermanentPercent(userMarketer.mar_count_permanent_percent);
  }, [userMarketer]);

  const getUserMarketer = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const userMarketer = await sendRequestGetUserMarketer(userMarketerID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!userMarketer) {
      return;
    }
    setUserMarketer(userMarketer);
  };

  const sendRequestGetUserMarketer = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let user;
    try {
      user = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/${userID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return user.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".content-wrapper");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidationAddMarketer =
      editMarketerValidation.validateFormInfoUser(dataForm);
    if (resultValidationAddMarketer != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationAddMarketer,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddUserMarketer = await sendRequestEditUserMarketer(
      userMarketerID,
      dataForm
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddUserMarketer) {
      return;
    }
    history.push("/user/marketer/all");
  };

  const sendRequestEditUserMarketer = async (userID, dataForm) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/manage/" + userID,
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return false;
    }
    return true;
  };

  const getDataForm = () => {
    return {
      first_name: document.querySelector("#first-name").value.trim(),
      last_name: document.querySelector("#last-name").value.trim(),
      mobile: document.querySelector("#mobile").value.trim(),
      identity_marketer: document
        .querySelector("#identity-marketer")
        .value.trim(),
      first_percent: document.querySelector("#first-percent").value.trim(),
      type_collaboration: typeCollaborationUser + "",
      permanent_percent: permanentPercent + "",
      count_permanent_percent: countPermanentPercent + "",
      active: document.querySelector("#active").checked ? 1 : 0,
    };
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">همه کاربران بازاریاب</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/user/marketer/all" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}

              {userMarketer && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    sendForm();
                  }}
                >
                  <div className="d-flex flex-column flex-lg-row">
                    <div className="flex-1 form-group px-lg-2">
                      <label>شماره موبایل</label>
                      <span className="text-danger">*</span>
                      <input
                        type="number"
                        className="form-control"
                        id="mobile"
                        defaultValue={userMarketer.mobile}
                        placeholder="09121234567"
                        onWheel={(event) => event.currentTarget.blur()}
                        required
                      />
                    </div>
                    <div className="flex-1 form-group px-lg-2 px-lg-2">
                      <label>شناسه بازاریابی</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="identity-marketer"
                        defaultValue={userMarketer.mar_identity_marketer}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-flex flex-column flex-lg-row">
                    <div className="flex-1 form-group px-lg-2">
                      <label>نام</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="first-name"
                        defaultValue={userMarketer.first_name}
                        required
                      />
                    </div>
                    <div className="flex-1 form-group px-lg-2 px-lg-2">
                      <label>نام خانوادگی</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="last-name"
                        defaultValue={userMarketer.last_name}
                        required
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center py-2">
                    <label className="pl-2">درصد اولیه</label>
                    <input
                      style={{ width: "80px" }}
                      max="100"
                      min="1"
                      type="number"
                      className="form-control"
                      id="first-percent"
                      defaultValue={userMarketer.mar_first_percent}
                      onWheel={(event) => event.currentTarget.blur()}
                      required
                    />
                  </div>
                  <div className="d-flex align-items-center py-2">
                    <label className="pl-2">نوع همکاری : </label>
                    <span className="px-2">
                      <span className="pl-2">
                        <input
                          className="hover"
                          type="radio"
                          name="type-collaboration"
                          defaultChecked={
                            typeCollaborationUser ==
                            typeCollaboration.typeCollaborationConstant
                              .WITHOUT_PERMANENT_PERCENT
                              ? "checked"
                              : console.log()
                          }
                          value={
                            typeCollaboration.typeCollaborationConstant
                              .WITHOUT_PERMANENT_PERCENT
                          }
                          onChange={() => {
                            setTypeCollaborationUser(
                              typeCollaboration.typeCollaborationConstant
                                .WITHOUT_PERMANENT_PERCENT
                            );
                          }}
                        />
                      </span>
                      <span>بدون درصد دائمی</span>
                    </span>
                    <span className="px-2">
                      <span className="pl-2">
                        <input
                          className="hover"
                          type="radio"
                          name="type-collaboration"
                          defaultChecked={
                            typeCollaborationUser ==
                            typeCollaboration.typeCollaborationConstant
                              .WITH_LIMITED_PERMANENT_PERCENT
                              ? "checked"
                              : console.log()
                          }
                          value={
                            typeCollaboration.typeCollaborationConstant
                              .WITH_LIMITED_PERMANENT_PERCENT
                          }
                          onChange={() => {
                            setTypeCollaborationUser(
                              typeCollaboration.typeCollaborationConstant
                                .WITH_LIMITED_PERMANENT_PERCENT
                            );
                          }}
                        />
                      </span>
                      <span>با درصد دائمی محدود</span>
                    </span>
                    <span className="px-2">
                      <span className="pl-2">
                        <input
                          className="hover"
                          type="radio"
                          name="type-collaboration"
                          defaultChecked={
                            typeCollaborationUser ==
                            typeCollaboration.typeCollaborationConstant
                              .WITH_UNLIMITED_PERMANENT_PERCENT
                              ? "checked"
                              : console.log()
                          }
                          value={
                            typeCollaboration.typeCollaborationConstant
                              .WITH_UNLIMITED_PERMANENT_PERCENT
                          }
                          onChange={() => {
                            setTypeCollaborationUser(
                              typeCollaboration.typeCollaborationConstant
                                .WITH_UNLIMITED_PERMANENT_PERCENT
                            );
                          }}
                        />
                      </span>
                      <span>با درصد دائمی نامحدود</span>
                    </span>
                  </div>

                  {typeCollaborationUser !=
                    typeCollaboration.typeCollaborationConstant
                      .WITHOUT_PERMANENT_PERCENT && (
                    <div className="d-flex align-items-center py-2">
                      <label className="pl-2">درصد دائمی</label>
                      <input
                        max="100"
                        min="1"
                        onWheel={(event) => event.currentTarget.blur()}
                        style={{ width: "80px" }}
                        type="number"
                        className="form-control"
                        id="permanent-percent"
                        value={permanentPercent}
                        onChange={(e) => {
                          setPermanentPercent(parseInt(e.target.value));
                        }}
                      />
                    </div>
                  )}

                  {typeCollaborationUser ==
                    typeCollaboration.typeCollaborationConstant
                      .WITH_LIMITED_PERMANENT_PERCENT && (
                    <div className="d-flex align-items-center py-2">
                      <label className="pl-2">تعداد درصد دائمی نامحدود </label>
                      <input
                        style={{ width: "100px" }}
                        min="1"
                        type="number"
                        className="form-control"
                        onWheel={(event) => event.currentTarget.blur()}
                        id="count-permanent-percent"
                        value={countPermanentPercent}
                        onChange={(e) => {
                          setCountPermanentPercent(parseInt(e.target.value));
                        }}
                      />
                    </div>
                  )}

                  <span>
                    <label className="pl-2"> فعال </label>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active"
                        name="active"
                        defaultChecked={
                          userMarketer.mar_active ? "checked" : ""
                        }
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>

                  <div className="py-2">
                    <button className="btn btn-success">ویرایش کردن</button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
